import React from 'react';
import db from './db';
import Popup from './Popup';
import TextEditor from './TextEditor';
import SearchPopupButton from './SearchPopupButton';
import SearchTable from './SearchTable';
var functions = require("./functions.js");

// ThirdPartyWebHookTable component
export default class ThirdPartyWebHookTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);

        let assigned=false;
        if( this.props.facilityId){
            assigned=false;
        }

        let tableRef = React.createRef();

        // initalize state
        this.state = {
            thirdPartyWebHooksList:[],
            selectedWebHook:false,
            third_party_client:"",
            post_type:"",
            warning:"",
            facility_name:"",
            assigned:assigned,
            popupDisplay:"",
            tableRef:tableRef
        }
    }
    componentDidMount() {
        this.state.tableRef.current.queryData();
    }
    // render
    render() {
        let qry=this.props.securityObject.httpServer + "api/get/ThirdPartyWebHooks?";
        if(this.props.facility_id){
            qry+=`facility_id=${this.props.facility_id}&`
        }        
        let cols=[];
        cols.push({ key: 'id', title:"id", width:10 });
        cols.push({ key: 'third_party_client', title:"Third Party Client", width:10 });
        cols.push({ key: 'post_type', title:"PostType", width:10 });
        cols.push({ key: 'post_timestamp', title:"Posted At", width:10, noquery:true });
        cols.push({ key: 'facility_name', title:"Facility", width:10 });
        cols.push({ key: 'status', title:"Status", width:10 });
        cols.push({ key: 'identifier', title:"Identifier", width:10 });
        cols.push({ key:'process_status',title:'Process Status', render:this.renderProcessStatus.bind(this)})
        cols.push({ key: 'shortHTML', title:"Description", width:60, render:this.renderHTML } );
        return (
            <div>
                <button className="" onClick={() => this.updateClients() }>Update Clients</button>
                <SearchTable columns={cols} 
                    securityObject={this.props.securityObject}
                    query={qry}
                    dataSource={this.state.thirdPartyWebHooksList}
                    onClick={this.editWebHook.bind(this)}
                    tableHeight="70vh"
                    ref={this.state.tableRef}
                    />
                <Popup
                    trigger={this.state.selectedWebHook}
                > 
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>Close</button>
                    </div>
                
                    <h4>
                        Third Party Client:{this.state.selectedWebHook.third_party_client}&nbsp;&nbsp;&nbsp;&nbsp;
                        Post Type:{this.state.selectedWebHook.post_type}&nbsp;&nbsp;&nbsp;&nbsp;
                        Posted At:{this.state.selectedWebHook.post_timestamp}&nbsp;&nbsp;&nbsp;&nbsp;
                        Client:{this.state.selectedWebHook.facility_name}&nbsp;&nbsp;&nbsp;&nbsp;
                        Status:{this.state.selectedWebHook.status}&nbsp;&nbsp;&nbsp;&nbsp;
                        Process Status:{this.state.selectedWebHook.process_status}&nbsp;&nbsp;&nbsp;&nbsp;
                        <button className="" onClick={() => this.reprocess() }>Reprocess</button>
                    </h4>
                    Facility:
                    <input id="inp_facility_id" defaultValue={this.state.selectedWebHook.facility_id} />
                    -
                    <input id="inp_facility_name" defaultValue={this.state.selectedWebHook.facility_name} />
                    <SearchPopupButton
                        securityObject={this.props.securityObject}
                        buttonLabel="Select Facility"
                        query={this.props.securityObject.httpServer + "api/get/facility?"}
                        columns={[
                                //{ key: 'id', title:"Facility id", width :20 }
                                { key: 'facility_name', title:"facility name", width :40 }
                                ,{ key: 'facility_address', title:"facility address", width :40 }
                                ,{ key: 'facility_city', title:"city", width :40 }
                                ,{ key: 'facility_state', title:"state", width :40 }
                                ,{ key: 'facility_zip', title:"zip", width :40 }
                                ]}
                        onClick={this.selectFacility.bind(this)}
                    >
                    </SearchPopupButton>
                    <br></br>
                    <div dangerouslySetInnerHTML={{ __html: this.state.selectedWebHook.shortHTML }} />
                    <br></br>
                    <TextEditor
                        defaultValue={this.state.selectedWebHook.post_data}
                        label="Web Hook Post"
                        id="post" 
                        name="hub_rules" 
                        type="json"  
                        className="JsonTextArea" 
                        >
                    </TextEditor>
                </Popup>       
            </div>
        );
    }

    // close the hub popup
    closePopup(){
        this.setState({
            selectedWebHook:false
        });
    }

    renderJSON(cellData, rowData, rowIndex){
        return React.createElement('textarea',{ className: 'warningNote' },cellData );
    }
    editWebHook( rowData, rowIndex ){   
        let disp="";

        this.setState({
            selectedWebHook:rowData
            ,popupDisplay:disp
        })
    }
    // display a checkbox
    renderHTML(cellData, rowData, rowIndex){
        var x = React.createElement("div",{ width:"1000px", dangerouslySetInnerHTML: {__html:cellData} } );
        //x.type="checkbox";
        return x; 
    }
    renderProcessStatus(cellData, rowData, rowIndex){
        let array=[];
        let portalId=functions.getHubspotPortalId();
        if(cellData=="SAVED"){
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation()
                        functions.openWindow(
                            process.env.REACT_APP_HTTP_SERVER
                            +'/api/reprocessWebhook?sessionId='
                            +this.props.securityObject.userSessionId
                            +'&thirdPartyId='
                            +rowData.id
                            ,"renderPop"
                            ,"left=100,top=100,width=320,height=320"
                        );
                    }
                    ,key:"buttonLinkHubSpot"+rowData.id
                }
                ,cellData + " Reprocess");
            array.push(btnPlus);
        } else {
            let btnPlus=React.createElement(
                'span'
                ,{}
                ,cellData);
            array.push(btnPlus);

        }
        // return div
        let div=React.createElement('div',{}, array );
        return div;
    }
    selectFacility(rowData){
        document.getElementById("inp_facility_id").value=rowData.id;
        document.getElementById("inp_facility_name").value=rowData.facility_name;
        let updateRecord={
            id:this.state.selectedWebHook.id
            , facility_id:rowData.id};
        db.saveData( this.props.securityObject
            , updateRecord
            ,"api/updateThirdPartyWebHooks"
            , this.afterUpdate()
            );        
    }
    afterUpdate(){
        this.setState({
            selectedWebHook:false
        })
        functions.sleep(1000).then(() => { 
            this.state.tableRef.current.queryData();
        });
    }
    updateClients(){
        let url=this.props.securityObject.httpServer
        +"api/update/thirdPartyWebHooksFacility?sessionId="
        +this.props.securityObject.userSessionId;
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=100,top=100`;
    window.open(url,'Update Third Party Client',params);
    }
    reprocess(){
        let url=this.props.securityObject.httpServer
        +"api/reprocessWebhook?sessionId="
        +this.props.securityObject.userSessionId
        +"&thirdPartyId="+this.state.selectedWebHook.id;
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=100,top=100`;
    window.open(url,'Update Third Party Client',params);
    }
//<div dangerouslySetInnerHTML={{ __html: this.state.selectedWebHook.shortHTML }} />
}